function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8652 7.07655L3.33683 32.9999C3.01667 33.5543 2.84727 34.1829 2.84547 34.8232C2.84368 35.4634 3.00956 36.093 3.32661 36.6492C3.64366 37.2054 4.10082 37.6689 4.65262 37.9936C5.20443 38.3183 5.83163 38.4929 6.47183 38.4999H37.5285C38.1687 38.4929 38.7959 38.3183 39.3477 37.9936C39.8995 37.6689 40.3567 37.2054 40.6737 36.6492C40.9908 36.093 41.1566 35.4634 41.1548 34.8232C41.1531 34.1829 40.9837 33.5543 40.6635 32.9999L25.1352 7.07655C24.8083 6.53775 24.3481 6.09227 23.799 5.78311C23.2499 5.47394 22.6303 5.31152 22.0002 5.31152C21.37 5.31152 20.7504 5.47394 20.2013 5.78311C19.6522 6.09227 19.192 6.53775 18.8652 7.07655V7.07655Z",
  stroke: "#FFC260",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22 16.5V23.8333",
  stroke: "#FFC260",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22 31.1665H22.0151",
  stroke: "#FFC260",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgAlertTriangle = function SvgAlertTriangle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlertTriangle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AlertTriangle.28aee535.svg";
export { ForwardRef as ReactComponent };